import {
  Stack,
  useColorMode,
  useColorModeValue,
  Box,
  Text,
} from "@chakra-ui/react";
import { displayForSmallDevice } from "../constants";
import { TbMessages } from "react-icons/tb";
import { BiGroup, BiSolidEnvelope } from "react-icons/bi";
import { BsCameraVideoFill } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import { AiFillHome } from "react-icons/ai";
import { IoRadioSharp } from "react-icons/io5";
import { CgScreen } from "react-icons/cg";
import useSmallScreen from "./useSmallScreen";
import { GoHomeFill } from "react-icons/go";
import {
  BsFillEnvelopeFill,
  BsFillHouseFill,
  BsFillTvFill,
} from "react-icons/bs";
import { BiSolidGroup } from "react-icons/bi";

function MobileFloatNav() {
  const sidebarTextColor = useColorModeValue("#222222", "#fff");
  const [smallScreen] = useSmallScreen();
  const sidebarBg = useColorModeValue("#fff", "#020b19");
  const { colorMode } = useColorMode();
  const navStyle = {
    direction: "row",
    alignItems: "center",
    spacing: "20px",
  };

  const navList = [
    { text: "Discover", link: "/", icon: GoHomeFill },
    {
      text: "Messaging",
      link: "/messaging",
      icon: BiSolidEnvelope,
    },
    // {
    //   text: "Live Streaming",
    //   link: "/live-streaming",
    //   icon: BsCameraVideoFill,
    // },
    {
      text: "Groups",
      link: "/group",
      icon: BiSolidGroup,
    },

    { text: "Meetings", link: "/meetings", icon: BsFillTvFill },
  ];
  return (
    <Stack
      h="70px"
      mt="10px !important"
      position={"relative"}
      pl={["0", "0", "0", "10px"]}
      w="100%"
    >
      <Stack
        spacing={["-10px", "15px"]}
        alignItems={"flex-start"}
        direction={["row", "column"]}
        bg={[sidebarBg, "unset"]}
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        h="50px"
        justifyContent={"space-between"}
      >
        <style>{`
      .notActive .icon-class{
        color: #A7A7A7;
      }
      `}</style>

        {navList.map(({ text, icon: Icon, link }, id) => {
          return (
            <NavLink
              to={link}
              className={({ isActive }) =>
                isActive ? "activeClass" : "notActive"
              }
              style={({ isActive }) =>
                isActive
                  ? {
                      ...(colorMode === "light"
                        ? {
                            color: "#4346E1",
                            padding: "10px 20px",
                          }
                        : {
                            color: "#0276fc",
                            padding: "10px 20px",
                            width: smallScreen ? "initial" : "200px",
                          }),
                    }
                  : {
                      color: sidebarTextColor,
                      padding: "10px 20px",
                      fontWeight: "bold",
                    }
              }
            >
              <Stack key={id} {...navStyle}>
                <Box>
                  <Icon className="icon-class" fontSize={"2.5em"} />
                </Box>

                <Text
                  fontWeight={"light"}
                  fontSize={".9em"}
                  display={displayForSmallDevice}
                >
                  {text}
                </Text>
              </Stack>
            </NavLink>
          );
        })}
      </Stack>
    </Stack>
  );
}

export default MobileFloatNav;
